import React from 'react'
import { Box } from 'rebass'
import ContentSectionHeading from '../../../components/ContentSectionHeader'
import themeMap from '../lib/themes'

const HeadingWidget = ({
  container: Container,
  title,
  heading,
  text,
  theme
}) => {
  const currentTheme = themeMap[theme] || themeMap.light
  return (
    <Box bg={currentTheme.backgroundColour}>
      <Container bg={currentTheme.backgroundColour}>
        <Box px={[0, 4, 20]}>
          <ContentSectionHeading
            reversed={currentTheme.reversed}
            title={title}
            heading={heading}
            fg={currentTheme.foregroundColour}
          >
            <div dangerouslySetInnerHTML={{ __html: text }} />
          </ContentSectionHeading>
        </Box>
      </Container>
    </Box>
  )
}

export default HeadingWidget
